import { PromoDetails } from '../data/promotion';
import ZapierAPI from '../services/ZapierAPI';

export const registerToPromotion = (email: string) => {
  if (email && PromoDetails.enabled()) {
    ZapierAPI.registerToPromotion(email);
  }
};
